// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3jSNE","colBig":"styles_colBig__1Q_m9","colSmall":"styles_colSmall__1B-lR","shopifyNameWrapper":"styles_shopifyNameWrapper__3h0UB"};